import React from "react";
import ReactDOM from "react-dom/client";
import "modern-normalize";
import App from './components/App';
import "./index.css";
import { Toaster } from 'react-hot-toast';

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
    <Toaster position="top-right" />
  </React.StrictMode>
);


